import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import { Center } from '@/components/ui/center'
import { Spinner } from '@/components/ui/spinner'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import FormInviteCooperators from '@/modules/formSettings/FormInviteCooperators'
import { selectFormBillingAccount } from '@/redux/slices/formBillingAccountSlice'
import { fetchFormInviteLinksThunk, selectFormInviteLinksByFormToken } from '@/redux/slices/formInviteLinkSlice'
import { fetchFormRolesThunk, selectFormRolesByFormToken } from '@/redux/slices/formRoleSlice'
import { formSelectors } from '@/redux/slices/formSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { Stack, useLocalSearchParams } from 'expo-router'
import { useEffect } from 'react'

export default function FormCooperatorsPage() {
  const { formToken } = useLocalSearchParams<{ formToken: string }>()
  const dispatch = useAppDispatch()
  const headerLeftItems = useWebBackButton(`/forms/${formToken}/setting/cooperators` as any)

  const loaded = useAppSelector(state => state.formInviteLinks.queryState[formToken]?.loaded)
  const currentUserIsOwnerOrAdmin = useAppSelector(state => state.currentUser.isOwnerOrAdmin)
  const currentBillingAccountId = useAppSelector(state => state.currentUser.user?.billingAccount.id)
  const currentBillingAccountName = useAppSelector(state => state.currentUser.user?.billingAccount.name)
  const form = useAppSelector(state => formSelectors.selectById(state.forms, formToken))
  const formBillingAccount = useAppSelector(state => selectFormBillingAccount(state, formToken))
  const formRoles = useAppSelector(state => selectFormRolesByFormToken(state, formToken))
  const inviteLinks = useAppSelector(state => selectFormInviteLinksByFormToken(state, formToken))

  useEffect(() => {
    dispatch(fetchFormRolesThunk({ formToken, first: 100 }))
    dispatch(fetchFormInviteLinksThunk({ formToken }))
  }, [dispatch, formToken])

  return (
    <>
      <Stack.Screen options={{ title: '邀请成员', ...buildScreenHeaderItems({ left: headerLeftItems }) }} />
      {!loaded || !form || !formBillingAccount || !currentBillingAccountId ? (
        <Center className="h-[50vh]">
          <Spinner />
        </Center>
      ) : (
        <FormInviteCooperators
          form={form}
          formRoles={formRoles}
          inviteLinks={inviteLinks}
          currentBillingAccountId={currentBillingAccountId}
          formBillingAccount={formBillingAccount}
          currentUserIsOwnerOrAdmin={currentUserIsOwnerOrAdmin}
          currentBillingAccountName={currentBillingAccountName ?? ''}
        />
      )}
    </>
  )
}
